import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CountUpModule } from 'ngx-countup';
import { NgxScrollTopModule } from 'ngx-scrolltop';
// import { StickyNavModule } from 'ng2-sticky-nav';
import { LightboxModule } from 'ngx-lightbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from "ngx-accordion";
import { LightgalleryModule } from 'lightgallery/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthService } from './authentication/_services/auth.service';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthInterceptor } from './shared/services/authInterceptor.service';
import { TokenInterceptor } from './shared/services/tokenInterceptor';
import { CokePopupComponent } from './coke-popup/coke-popup.component';
import { GoogleAuthService } from './shared/services/googleAuth.service';
import { LoadingInterceptor } from './loading.interceptor';
import { UploadDataComponent } from './upload-data/upload-data.component';

function appInitializer(authService: AuthService) {
    return () => {
        return new Promise((resolve) => {
            authService.getUserByToken().subscribe().add(resolve);
        });
    };
}
export function tokenGetter() {
    return localStorage.getItem("token");
}
@NgModule({
    declarations: [
        AppComponent,
        CokePopupComponent,
        UploadDataComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CarouselModule,
        CountUpModule,
        // TabsModule,
        NgxScrollTopModule,
        // StickyNavModule,
        LightboxModule,
        FormsModule,
        // AccordionModule,
        LightgalleryModule,
        NgSelectModule,
        FormsModule, ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot(),
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-bottom-right'
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
            }
        })], providers: [
            { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },

            // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
            {
                provide: APP_INITIALIZER,
                useFactory: appInitializer,
                multi: true,
                deps: [AuthService],
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: TokenInterceptor,
                multi: true,
            },
            {
                provide: HIGHLIGHT_OPTIONS,
                useValue: {
                    coreLibraryLoader: () => import('highlight.js/lib/core'),
                    languages: {
                        xml: () => import('highlight.js/lib/languages/xml'),
                        typescript: () => import('highlight.js/lib/languages/typescript'),
                        scss: () => import('highlight.js/lib/languages/scss'),
                        json: () => import('highlight.js/lib/languages/json')
                    },
                },
            },
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class AppModule { }


